export default "__VITE_ASSET__BMv1SSVf__"